import React, {useState, useEffect, Fragment} from 'react'
import flatstore from 'flatstore';
//import Category from '../../../components/ui/Category';

import Image from '../../../components/ui/Image'

import Loader from '../../../components/ui/Loader';
import LoadModules from '../../../components/ui/LoadModules'
import {getStatic} from '../../../utils/services';
//import parse from 'html-react-parser';
import Meta from '../../../components/ui/Meta';

import home_hero from '../../../assets/img/home/hero_section.jpg';
import {isNil} from 'lodash';


const Home = ({loading, static_data, match}) => {
    const [data, setData] = useState(null);
    const [modules, setModules] = useState(0);
    const {filter} = match.params;
    
    useEffect(() => {
        static_data = null;
    }, [])

    useEffect(() => {

		if (isNil(static_data)) {
            getStatic('home', 'static_data');
        }
        if(!data){
            setData(static_data);
        }
        
		if(static_data && static_data.modules !== null){
            setModules(static_data.modules);
		}
		
    }, [static_data]);
    
    if (loading) {
		return <Loader />
	} else {
        
        return (
            <Fragment>
                 {data &&
                    <Meta
                        title={data.seo_title ? data.seo_title : data.title}
                        description={data.seo_description && data.seo_description}
                    />
                 }

                <LoadModules modules={modules} filter={filter} moduleData={null} type="top" />

                <LoadModules modules={modules} filter={filter} moduleData={null} type="bottom" />
          
            </Fragment>
        )
    }
}

export default flatstore.connect(['loading', 'static_data'])(Home);
